import type { MigrationManifest, PersistedState } from 'redux-persist'
import type { WorkflowState } from '@/reducers/workflow'
import { Finalisation } from '@/workflows/modules'

type PersistedRootState = PersistedState & { workflow: WorkflowState }

const removedPaymentPaths = ['/summary', '/payment/summary']

// Redirects a path of the removed summary steps to the Finalisation step
const migratePath = (path: string) =>
  removedPaymentPaths.includes(path) ? Finalisation.path : path

// Moves prospects persisted on the removed summary steps to the Finalisation step
export const migrations: MigrationManifest = {
  0: (state) => {
    if (!state) return state

    const { workflow } = state as PersistedRootState
    const migratedState: PersistedRootState = {
      ...state,
      workflow: {
        ...workflow,
        path: migratePath(workflow.path),
        flow: Array.from(new Set(workflow.flow.map(migratePath)))
      }
    }
    return migratedState
  }
}
